import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

const DocumentTemplatePage_DocumentTemplate_UpdatePrintSettings_Mutation =
  graphql(`
    mutation DocumentTemplatePage_DocumentTemplate_UpdatePrintSettings(
      $printableId: Id!
      $printSettings: PrintSettingsInput!
    ) {
      updateDocumentTemplatePrintSettings(
        printableId: $printableId
        printSettings: $printSettings
      ) {
        _id
      }
    }
  `);

export const useUpdateDocumentTemplatePrintSettingsMutation = () =>
  useGraphQLMutation(
    DocumentTemplatePage_DocumentTemplate_UpdatePrintSettings_Mutation,
  );
